import React from 'react'
import { Text } from '@grammarly/design-system'
import { FormattedMessage } from 'react-intl'
import cn from 'classnames'

import { useExperimentService } from '@lib/hooks'
import { withPublicAssetUrl } from '@lib/utils/cdn'
import { SignUpProductRecButton } from '@components/item/cta-button/signup-product-recommendation'
import { ButtonColor } from '@components/ui-lib/button'
import { useTool } from '../tool-context'

import styles from '../tool.module.scss'

export const ToolNextBestAction: React.FC = () => {
  const { isLoading, outputContent, nextBestActionCopy, textLimitExceededCopy } = useTool()
  const { isToolsRedesign2_3AnonEnabled } = useExperimentService()

  const isVisible = outputContent && !isLoading

  if (isToolsRedesign2_3AnonEnabled()) {
    return (
      <div
        aria-hidden={!isVisible}
        className={styles.tool2_3NextBestActionContainer}
        style={{
          background: `no-repeat left / cover url(${withPublicAssetUrl('tools/next-best-action-background.png')})`,
          opacity: isVisible ? 1 : 0,
        }}
      >
        <div className={styles.tool2_3NextBestActionGradient}></div>
        <Text
          variant="heading-xxsmall"
          as="span"
          className={cn(styles.tool2_3NextBestActionCopy, styles.tools2_3NextBestActionItem)}
        >
          {textLimitExceededCopy ?? nextBestActionCopy}
        </Text>
        <SignUpProductRecButton
          compact
          color={ButtonColor.PrimaryOnDarkBg}
          text={
            <Text variant="text-medium" as="span" color="base-default" className={styles.toolNextBestActionButton}>
              <strong>
                <FormattedMessage id="phrase.getGrammarly" description="Get Grammarly" defaultMessage="Get Grammarly" />
              </strong>
            </Text>
          }
          placement="Section"
          toQueryParam="editor"
          className={cn(styles.tools2_3NextBestActionItem, styles.tool2_3NextBestActionButton)}
        />
      </div>
    )
  }

  return (
    <div className={styles.toolNextBestActionContainer} style={{ opacity: isVisible ? 1 : 0 }} aria-hidden={!isVisible}>
      <Text variant="text-small" as="span" color="base-default" className={styles.toolNextBestActionCopy}>
        {nextBestActionCopy}
      </Text>

      <SignUpProductRecButton
        compact
        color={ButtonColor.WDK24SecondaryLightBg}
        text={
          <Text variant="text-medium" as="span" color="brand-default" className={styles.toolNextBestActionButton}>
            <strong>
              <FormattedMessage id="phrase.getGrammarly" description="Get Grammarly" defaultMessage="Get Grammarly" />
            </strong>
            &nbsp;
            <FormattedMessage id="phrase.itsFree" description="Sign up prompt value prop" defaultMessage="It's free" />
          </Text>
        }
        showArrow
        placement="Section"
        toQueryParam="editor"
      />
    </div>
  )
}
